<template>
  <svg :width="width || 11" :height="height || 8" viewBox="0 0 11 8" fill="none" >
<path d="M5.13932 6.95373L1.00313 2.19059C0.515 1.63017 0.911715 0.75 1.65254 0.75H9.92492C10.0907 0.749857 10.253 0.797864 10.3925 0.888273C10.5319 0.978681 10.6425 1.10766 10.711 1.25976C10.7795 1.41186 10.8031 1.58064 10.7788 1.74588C10.7546 1.91112 10.6836 2.06582 10.5743 2.19146L6.43814 6.95286C6.35719 7.04619 6.25736 7.12099 6.14535 7.17224C6.03334 7.22348 5.91175 7.25 5.78873 7.25C5.66571 7.25 5.54412 7.22348 5.43211 7.17224C5.3201 7.12099 5.22027 7.04619 5.13932 6.95286V6.95373Z" :fill="fill || '#383F51'"/>
</svg>
        
</template>
<script>
export default {
  props: {
    fill: {
      type: String,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
  },
};
</script>